import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-45",
  "use": "icon-button_icon-45-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-45\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12.391 15.629a5.985 5.985 0 00-.452-1.483M21.323 8.847a4.992 4.992 0 01-4.241 1.415l-2.534 2.533a8.003 8.003 0 01-1.71 8.78h0L1.524 10.261a8.003 8.003 0 018.781-1.71l2.533-2.532a4.992 4.992 0 011.414-4.243h0zM7.257 15.995l-2.969 2.969\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol